import React from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Wrapper de transition entre les pages.
 * - Au changement de `location.pathname`, le wrapper est remonté (key=pathname)
 *   ce qui déclenche l'animation CSS d'entrée (.c2r-page-enter).
 * - Très léger : pas de lib externe, juste un key + une classe.
 * - Respecte prefers-reduced-motion (CSS coupe l'animation).
 */
export function PageTransition({ children }) {
  const location = useLocation();
  return (
    <div key={location.pathname} className="c2r-page-enter" data-testid="page-transition">
      {children}
    </div>
  );
}
